module.exports = "/_next/static/images/c771fb1aeafff14bc36a3bf1114bb77b-phone-with-app-open-and-card@1x-xs.jpg.webp";